module.exports = __webpack_public_path__ + "img/ic_hub_disconnected.cf4236d9.svg";